import { render, staticRenderFns } from "./forgot-password-view.vue?vue&type=template&id=415f3786"
import script from "./forgot-password-view.vue?vue&type=script&lang=js"
export * from "./forgot-password-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports